
export default function withParams(path, {dataViewId, accountId, limit, sortOrder }) {
  const params = new URLSearchParams();
  if (dataViewId) {
    params.append("data_view_id", dataViewId);
  }
  if(accountId) {
    params.append("account_id", accountId);
  }
  if(limit) {
    params.append("limit", limit);
  }
  if(sortOrder) {
    params.append("order", sortOrder);
  }
  return path + "?" + params;
}

